// extracted by mini-css-extract-plugin
export default {"enlargeButton":"EnlargeButton_enlargeButton__nw4tN","iconSize":"EnlargeButton_iconSize__IlA47"};